import { Component } from '@angular/core';
import { Events, NavController } from 'ionic-angular';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  constructor(public navCtrl: NavController, public events: Events) {

  }

  ngOninit(){
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts